export type RescueRole = 'V' | 'R';

class UtilService {
  normalizeRole = (role: string | undefined): RescueRole | undefined => {
    const upper = role?.toUpperCase();
    return upper === 'V' || upper === 'R' ? upper : undefined;
  };

  isEmpty = (value: any): boolean => {
    if (
      value === '' ||
      value === null ||
      value === undefined ||
      (value !== null && typeof value === 'object' && !Object.keys(value).length)
    ) {
      return true;
    } else {
      return false;
    }
  };

  getTime(saveTime: any) {
    let date;
    if (typeof saveTime == 'string') {
      date = new Date(saveTime.replace(/-/g, '/'));
    } else {
      date = new Date(saveTime);
    }
    const hours = String(date.getHours()).padStart(2, '0');
    const min = String(date.getMinutes()).padStart(2, '0');
    const sec = String(date.getSeconds()).padStart(2, '0');
    return `${hours}:${min}:${sec}`;
  }

  getUTCDate(tim = Date.now()) {
    const now = new Date(tim); // 현재 시간
    const utcNow = now.getTime() + now.getTimezoneOffset() * 60 * 1000; // 현재 시간을 utc로 변환한 밀리세컨드값
    return new Date(utcNow).getTime();
  }

  distanceUnit(meter) {
    let ret = '';
    if (meter < 1000) {
      ret = meter.toFixed(1) + 'm';
    } else {
      // let km = Math.floor(meter / 1000);
      // let m = meter - km * 1000;
      ret = (meter / 1000).toFixed(1) + 'km';
    }
    return ret;
  }

  timeUnit(min) {
    const m = min % 60;
    const h = (min - m) / 60;
    return (h < 10 ? '0' : '') + h.toString() + ':' + (m < 10 ? '0' : '') + m.toString();
  }

  getShortStr(str, maxLen) {
    let ret = str;
    if (str.length > maxLen) {
      ret = str.substring(0, maxLen) + '...';
    }
    return ret;
  }

  getGenderColor = (gender) => {
    return gender === 'female' ? '#ff00ff' : '#2A7Bff';
  };

  getDistanceFromLatLonInKm = (lat1, lng1, lat2, lng2) => {
    function deg2rad(deg) {
      return deg * (Math.PI / 180);
    }

    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1); // deg2rad below
    const dLon = deg2rad(lng2 - lng1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d;
  };

  generateRandomCode = (n) => {
    let str = '';
    for (let i = 0; i < n; i++) {
      str += Math.floor(Math.random() * 10);
    }
    return str;
  };

  isSameDate = (date1, date2) => {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  };

  isSameDateAndTime = (date1, date2) => {
    return date1.getTime() === date2.getTime();
  };

  isMobileFormat = (tel: any): string => {
    return tel.replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, '$1-$2-$3').replace(/-{1,2}$/g, '');
  };

  telValidator = (args) => {
    if (/^(01[0-9]{1}-?[0-9]{4}-?[0-9]{4}|01[0-9]{8})$/.test(args)) {
      return true;
    }
    return false;
  };

  convertToDms = (decimalDegrees, isLongitude) => {
    // 방향 결정
    const direction = decimalDegrees < 0 ? (isLongitude ? 'W' : 'S') : isLongitude ? 'E' : 'N';
    // 절대값 변환
    const absoluteDegrees = Math.abs(decimalDegrees);
    // 도 계산
    const degrees = Math.floor(absoluteDegrees);
    // 분 계산
    const minutesFloat = (absoluteDegrees - degrees) * 60;
    const minutes = Math.floor(minutesFloat);
    // 초 계산 (소수점 2자리까지)
    const seconds = Number(((minutesFloat - minutes) * 60).toFixed(2));

    return `${direction}${degrees}°${minutes}'${seconds}"`;
  };

  formatSpeed = (speed) => {
    return speed !== null ? `${Number(speed).toFixed(2)}kn` : '없음';
  };

  formatDirection = (degrees) => {
    return degrees !== null ? `${Number(degrees).toFixed(2)}°` : '없음';
  };

  formatPhoneNumber = (value: string) => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;

    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) {
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
    }
    if (phoneNumberLength < 11) {
      return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
    }
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7, 11)}`;
  };
}

export const utilService = new UtilService();
